import { motion } from "framer-motion";
import vision from "@/assets/images/visionImg.png";

export default function VisionSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-linear-to-b from-green-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left side - Image with animation */}
          <motion.div
            className="flex justify-center lg:justify-start"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.img
              src={vision}
              alt="Our Vision"
              className="w-full h-full max-w-md object-cover rounded-2xl"
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{
                duration: 1.2,
                ease: "easeOut",
                delay: 0.2,
              }}
              whileHover={{ scale: 1.03 }}
              viewport={{ once: true }}
            />
          </motion.div>

          {/* Right side - Text animation */}
          <motion.div
            className="space-y-6 lg:ml-10"
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div>
              <h2 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 mb-4 tracking-tight leading-none">
                Our Vision
              </h2>
              <div className="w-16 h-1.5 bg-emerald-500 rounded-full"></div>
            </div>

            <p className="text-base sm:text-lg lg:text-xl text-slate-600 leading-relaxed">
              At{" "}
              <span className="font-semibold text-emerald-700">
                SMARTLY ORDERS
              </span>
              , our vision is to become the leading all-in-one platform for
              food, groceries, and everyday essentials, while creating a
              smarter, more sustainable future where convenience, affordability,
              and responsible consumption go hand in hand.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
